import React from "react"
import PropTypes from "prop-types"

const Logo = ({ width, height, fillColor, fillColorDot }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 520 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M330.29 29.2451L338.285 54.3845C338.193 54.4805 338.1 54.5757 338.006 54.6701C335.119 57.5567 331.563 59 327.336 59C323.109 59 319.552 57.5567 316.666 54.6701C313.779 51.7835 312.336 48.1753 312.336 43.8454C312.336 39.4124 313.779 35.8557 316.666 33.1753C319.552 30.3918 323.109 29 327.336 29C328.36 29 329.345 29.0817 330.29 29.2451Z"
      fill={fillColorDot}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.384 24.864C16.032 20.16 21.216 17.856 27.936 17.856C34.368 17.856 39.936 20.352 44.448 25.248C49.056 30.144 51.36 36.096 51.36 43.2C51.36 50.304 49.056 56.352 44.448 61.248C39.936 66.144 34.368 68.544 27.936 68.544C21.216 68.544 16.032 66.24 12.384 61.536V67.2H0V0H12.384V24.864ZM12.384 43.2C12.384 47.136 13.632 50.4 16.128 52.992C18.624 55.488 21.792 56.736 25.632 56.736C29.472 56.736 32.64 55.488 35.136 52.992C37.728 50.4 38.976 47.136 38.976 43.2C38.976 39.264 37.728 36 35.136 33.504C32.64 30.912 29.472 29.664 25.632 29.664C21.792 29.664 18.624 30.912 16.128 33.504C13.632 36 12.384 39.264 12.384 43.2Z"
      fill={fillColor}
    />
    <path
      d="M82.1738 57.024C88.6058 57.024 92.7337 53.088 92.7337 45.12V19.2H105.118V67.2H92.7337V61.824C89.7578 66.336 84.9577 68.544 78.4297 68.544C73.1497 68.544 68.8298 66.816 65.3737 63.264C62.0137 59.712 60.2857 54.912 60.2857 48.672V19.2H72.6697V47.136C72.6697 53.568 76.4137 57.024 82.1738 57.024Z"
      fill={fillColor}
    />
    <path
      d="M129.804 19.2H117.42V67.2H129.804V44.256C129.804 39.648 131.244 36.384 134.22 34.368C137.196 32.352 140.652 31.584 144.396 32.064V18.24C137.868 18.24 132.108 21.312 129.804 27.456V19.2Z"
      fill={fillColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M197.954 43.2C197.954 44.832 197.762 46.464 197.474 48.288H161.282C162.914 54.336 167.426 57.312 174.818 57.312C179.521 57.312 183.17 55.68 185.57 52.512L195.554 58.272C190.85 65.088 183.842 68.544 174.626 68.544C166.658 68.544 160.322 66.144 155.521 61.344C150.721 56.544 148.322 50.496 148.322 43.2C148.322 36 150.722 29.952 155.426 25.152C160.13 20.256 166.274 17.856 173.666 17.856C180.674 17.856 186.53 20.256 191.042 25.152C195.65 30.048 197.954 36 197.954 43.2ZM173.666 28.992C167.042 28.992 162.53 32.544 161.09 38.688H185.57C184.13 32.16 179.33 28.992 173.666 28.992Z"
      fill={fillColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M243.664 24.864C239.92 20.16 234.736 17.856 228.016 17.856C221.584 17.856 216.112 20.352 211.504 25.248C206.992 30.144 204.688 36.096 204.688 43.2C204.688 50.304 206.992 56.352 211.504 61.248C216.112 66.144 221.584 68.544 228.016 68.544C234.736 68.544 239.92 66.24 243.664 61.536V67.2H256.048V19.2H243.664V24.864ZM220.816 52.992C218.32 50.4 217.072 47.136 217.072 43.2C217.072 39.264 218.32 36 220.816 33.504C223.312 30.912 226.48 29.664 230.32 29.664C234.16 29.664 237.328 30.912 239.824 33.504C242.416 36 243.664 39.264 243.664 43.2C243.664 47.136 242.416 50.4 239.824 52.992C237.328 55.488 234.16 56.736 230.32 56.736C226.48 56.736 223.312 55.488 220.816 52.992Z"
      fill={fillColor}
    />
    <path
      d="M289.357 57.024C295.789 57.024 299.917 53.088 299.917 45.12V19.2H312.301V29.0451C308.227 32.9756 306.336 38.1056 306.336 43.8454C306.336 49.6014 308.298 54.7241 312.301 58.7901V67.2H299.917V61.824C296.941 66.336 292.142 68.544 285.613 68.544C280.333 68.544 276.013 66.816 272.557 63.264C269.198 59.712 267.469 54.912 267.469 48.672V19.2H279.853V47.136C279.853 53.568 283.597 57.024 289.357 57.024Z"
      fill={fillColor}
    />
    <path
      d="M383.888 48.768L375.152 19.2H363.44L354.704 48.672L346.544 19.2H333.392L348.656 67.2H360.464L369.296 38.112L378.128 67.2H389.936L405.2 19.2H392.048L383.888 48.768Z"
      fill={fillColor}
    />
    <path
      d="M457.616 48.288C457.904 46.464 458.096 44.832 458.096 43.2C458.096 36 455.792 30.048 451.184 25.152C446.672 20.256 440.816 17.856 433.808 17.856C426.416 17.856 420.272 20.256 415.568 25.152C410.864 29.952 408.464 36 408.464 43.2C408.464 50.496 410.864 56.544 415.664 61.344C420.464 66.144 426.8 68.544 434.768 68.544C443.984 68.544 450.992 65.088 455.696 58.272L445.712 52.512C443.312 55.68 439.664 57.312 434.96 57.312C427.568 57.312 423.056 54.336 421.424 48.288H457.616ZM421.232 38.688C422.672 32.544 427.184 28.992 433.808 28.992C439.472 28.992 444.272 32.16 445.712 38.688H421.232Z"
      fill={fillColor}
    />
    <path
      d="M495.637 17.856C488.917 17.856 483.733 20.16 480.085 24.864V0H467.701V67.2H480.085V61.536C483.733 66.24 488.917 68.544 495.637 68.544C502.069 68.544 507.637 66.144 512.149 61.248C516.757 56.352 519.061 50.304 519.061 43.2C519.061 36.096 516.757 30.144 512.149 25.248C507.637 20.352 502.069 17.856 495.637 17.856ZM483.829 52.992C481.333 50.4 480.085 47.136 480.085 43.2C480.085 39.264 481.333 36 483.829 33.504C486.325 30.912 489.493 29.664 493.333 29.664C497.173 29.664 500.341 30.912 502.837 33.504C505.429 36 506.677 39.264 506.677 43.2C506.677 47.136 505.429 50.4 502.837 52.992C500.341 55.488 497.173 56.736 493.333 56.736C489.493 56.736 486.325 55.488 483.829 52.992Z"
      fill={fillColor}
    />
  </svg>
)

Logo.propsTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fillColor: PropTypes.string,
  fillColorDot: PropTypes.string,
}

Logo.defaultProps = {
  width: "110",
  height: "15",
  fillColor: "#192A3E",
  fillColorDot: "#10F6B1",
}

export default Logo
